import { Key } from '@briebug/ngrx-auto-entity';

export class MaterialVendor {
  @Key id?: number;
  vendor: string;
  vendorName?: string;
  categories: number[];
}
